import React from 'react'
import { getProgressColor } from 'utils/color-map'
import { Progress } from 'antd'
import styled from 'styled-components'

interface Props {
  task: any
  width?: number
  hideStatus?: boolean
}

const ProgressCircle: React.FC<Props> = (props) => {
  const { task, width = 70, hideStatus = false } = props
  const { State, TaskStatus } = task

  const getMcText = () => {
    switch (TaskStatus) {
      case 'APPV':
        return Approved
      case 'REJT':
        return Reject
      default:
        return
    }
  }

  const getCmText = () => {
    switch (TaskStatus) {
      case 'APPV':
        return Approved
      case 'REJT':
        return Reject
      default:
        return
    }
  }

  const getCmStatus = () => {
    switch (TaskStatus) {
      case 'INIT':
      case 'INPRO':
        return 'APPV'
      default:
        return TaskStatus
    }
  }

  const getPJText = () => {
    switch (TaskStatus) {
      case 'APPV':
        return Approved
      case 'INIT':
      case 'INPRO':
        return Inprogress
      default:
        return
    }
  }

  let text
  let status = TaskStatus

  switch (State) {
    case 'MC':
      text = getMcText()
      break
    case 'CM':
      text = getCmText()
      status = getCmStatus()
      break
    case 'PJPO':
      text = getPJText()
      status = TaskStatus === 'INIT' ? 'inpro' : TaskStatus
      break
    default:
      break
  }

  const taskConfig = getProgressColor(
    status,
    task.Progress,
    task.LastReqProgress,
    task.LastCurProgress
  )
  return (
    <Data>
      <Progress
        type="circle"
        percent={taskConfig.progress}
        successPercent={taskConfig.success}
        width={width}
        strokeWidth={9}
        strokeColor={taskConfig.color}
        format={(percent) => `${task.Progress}%`}
        className={taskConfig.color ? '' : taskConfig.className}
        strokeLinecap="round"
      />
      {!hideStatus && text}
    </Data>
  )
}

const Data = styled.div`
  text-align: center;
  width: 100%;
  .task-progress {
    width: 100%;
    text-align: left;
    .ant-progress-outer {
      width: 80%;
    }
    .ant-progress-text {
      padding-left: 10px;
    }
  }
`

const TextStatus = styled.div`
  font-size: 18px;
  width: auto;
  display: block;
  text-align: center;
`

const Approved = (
  <TextStatus style={{ color: '#5bc79e' }}>อนุมัติแล้ว</TextStatus>
)

const Reject = <TextStatus style={{ color: '#d0494c' }}>ไม่อนุมัติ</TextStatus>

const Inprogress = (
  <TextStatus style={{ color: '#efc122' }}>รออนุมัติ</TextStatus>
)

export default ProgressCircle
